import '../login/login.scss';
import SignUpForm from '../../components/signup-form/signup-form';

const SignUp = () => {
    
    return(
        <div className='login_container'>
            <SignUpForm />
        </div>
    );
}

export default SignUp;